export const STARTTIME = '07:00:00';
export const STARTTIMELA = '00:00:00';
export const STARTTIMESF = '00:00:00';
export const LAENDTIME = '09:00:00';
export const SFENDTIME = '10:00:00';